<script>
import QzNumberInput from '@/components/QzNumberInput/QzNumberInput.vue';

export default {
  name: 'currency-input',
  extends: QzNumberInput,
  props: {
    withoutSeparators: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
